import React from 'react';

const EmpresasIcon = ({ color = 'currentColor', size = 20 }) => (
  <svg width={size} height={size} viewBox="773 178 22 20" fill="none">
    <path
      d="M793 182H789V180C789 178.9 788.1 178 787 178H781C779.9 178 779 178.9 779 180V183.38L774.11 185.83C773.777 185.996 773.496 186.251 773.3 186.567C773.104 186.883 773 187.248 773 187.62V197C773 197.55 773.45 198 774 198H794C794.55 198 795 197.55 795 197V184C795 182.9 794.1 182 793 182ZM793 196H779V187.99L777 189V196H775V187.62L780.45 184.9C780.615 184.817 780.754 184.69 780.851 184.533C780.948 184.376 780.999 184.195 781 184.01V180.01H787V183.01C787 183.56 787.45 184.01 788 184.01H793V196.01V196Z"
      fill={color}
    />
    <path
      d="M783 186H785V188H783V186ZM783 190H785V192H783V190ZM783 182H785V184H783V182ZM789 190H791V192H789V190ZM789 186H791V188H789V186Z"
      fill={color}
    />
  </svg>
);

export default EmpresasIcon;
